export default {
      id: "removeCircle-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#removeCircle-usage",
      toString: function () {
        return this.url;
      }
    }